import { MapPinAssetsLarge, theme } from '@sg/garnish';

import { type MarkerImages } from './Map.types';

// ─── Marker ──────────────────────────────────────────────────────────────────

export const MARKER_SIZE = 48;
export const MARKER_ICON_SIZE = MARKER_SIZE / 2;

// ─── Padding ─────────────────────────────────────────────────────────────────

export const DEFAULT_EDGE_PADDING = theme.spacing['10'];
export const DEFAULT_EDGE_PADDINGS = [
  DEFAULT_EDGE_PADDING,
  DEFAULT_EDGE_PADDING,
  DEFAULT_EDGE_PADDING,
  DEFAULT_EDGE_PADDING,
];

// ─── Zoom ────────────────────────────────────────────────────────────────────

export const MAX_ZOOM_LEVEL = 17;

// ─── Assets ──────────────────────────────────────────────────────────────────

export const PIN_IMAGES = {
  'pin-customer': MapPinAssetsLarge.PinCustomer,
  'pin-courier': MapPinAssetsLarge.PinCourier,
  'pin-location': MapPinAssetsLarge.PinLocation,
  'pin-home': MapPinAssetsLarge.PinHome,
  'pin-work': MapPinAssetsLarge.PinWork,
  'pin-custom': MapPinAssetsLarge.PinCustom,
  'pin-minimized-open': MapPinAssetsLarge.PinMinimizedOpen,
  'pin-minimized-closed': MapPinAssetsLarge.PinMinimizedClosed,
  'pin-outpost': MapPinAssetsLarge.PinOutpost,
  'pin-outpost-closed': MapPinAssetsLarge.PinOutpostClosed,
  'pin-pickup-closed': MapPinAssetsLarge.PinPickupClosed,
  'pin-pickup': MapPinAssetsLarge.PinPickup,
} as const satisfies MarkerImages;

// ─── Transitions ─────────────────────────────────────────────────────────────

export const TRANSITION_DURATION_WEB = 1500;
